module.exports = __webpack_public_path__ + "img/portugal-blood-diseases-female.91ebb52c.png";